import { ref, computed, watch, getCurrentInstance } from 'vue';
import { useStore } from '@/utils/vue-api';
import { useModuleAttrs } from '@rebuild/hooks/useModuleAttrs';

export function usePureModule() {
	const vm = getCurrentInstance();
	const store = useStore();
	const isMobile = computed(() => store.getters.isMobileMode);

	const moduleState = ref('pending');
	const finish = () => {
		moduleState.value = 'fulfilled';
	};

	watch(
		() => moduleState.value,
		val => {
			if (parent.postMessage) {
				parent.postMessage({ type: 'restate', state: val }, '*');
			}
		},
		{ immediate: true }
	);

	const activeModule = ref();
	const { getModuleId, getModuleProps } = useModuleAttrs();

	const initModuleRender = () => {
		activeModule.value = { moduleId: vm.proxy.$route.params?.moduleId };
		finish();
	};
	initModuleRender();

	return {
		isMobile,
		activeModule,
		getModuleId,
		getModuleProps
	};
}
